import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';
import OrdersService from '@/services/Orders';
let singleton = Symbol();
let singletonEnforcer = Symbol();

class CardService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._indentPayment = null;
    this._methods = null;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new CardService(singletonEnforcer);
    }
    return this[singleton];
  }

  initStripe() {
    return new Promise((resolve, reject) => {
      if (this._cardElement) {
        resolve(this._cardElement);
        return;
      }
      axios.get(`/api/v2/orders/${OrdersService.cart.id}/payments/${OrdersService.cart.cartPayment.id}/configuration`).then(res => {
        if (res.data.publishable_key) {
          this._stripe = window.Stripe(res.data.publishable_key);
          this._indentPayment = res.data.client_secret;
          this._cardElement = this.getCardElements();
          resolve(this._cardElement);
        } else reject(new Error('no publish key defined'));
      }).catch(reject);
    });
  }

  checkPayment(cardPayment, expected = {}) {
    const seq = axios.get(`/api/v2/orders/${OrdersService.cart.id}/payments/${cardPayment.id}/check`, { params: expected });
    seq.catch( console.error );
    return seq;
  }

  getMethods() {
    return new Promise((resolve) => {
      if (this._methods) {
        resolve(this._methods);
        return;
      }
      axios.get(`/api/v2/payments/methods`).then(res => {
        this._methods = res.data['hydra:member'];
        resolve(this._methods);
      })
    })
  }

  destroy() {
    if (this._cardElement.cardNumber) {
      this._cardElement.cardNumber.unmount();
      this._cardElement.cardNumber.destroy();
    }
    if (this._cardElement.cardExpiry) {
      this._cardElement.cardExpiry.unmount();
      this._cardElement.cardExpiry.destroy();
    }
    if (this._cardElement.cardCvc) {
      this._cardElement.cardCvc.unmount();
      this._cardElement.cardCvc.destroy();
    }
    this._cardElement = null;
    this._indentPayment = null;
  }

  getCardElements() {
    const options = {
      style: {
        base: {
          color: '#32325D',
          fontFamily: 'Poppins',
          fontSize: '18px',
          fontSmoothing: 'antialiased',
          lineHeight: '48px',
          '::placeholder': {
            color: '#CFD7DF',
          },
          ':-webkit-autofill': {
            color: '#e39f48',
          }
        }
      },
      classes: {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid',
      }
    };
    const cardElement = this._stripe.elements({
      fonts: [{
        cssSrc: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap',
      }]
    });
    const card = {
      cardElement: cardElement
    }
    card.cardNumber = card.cardElement.create('cardNumber', {
      ...options,
      preferredNetwork: ['cartes_bancaires', 'mastercard', 'visa'],
      showIcon: true,
      iconStyle: 'solid'
    });
    card.cardExpiry = card.cardElement.create('cardExpiry', options);
    card.cardCvc = card.cardElement.create('cardCvc', options);
    return card;
  }

  paymentFree(order) {
    const seq = axios.get(`/api/v2/orders/${order.id}/complete/free`);
    seq.catch( console.error );
    return seq;
  }

  payment(cardNumber) {
    return new Promise((resolve, reject) => {
      if (!this._indentPayment) return reject(new Error('indent payment not exist'));
      this._stripe.confirmCardPayment(this._indentPayment, {
        payment_method: {
          card: cardNumber
        },
      }).then(result => {
        if (result.paymentIntent) {
          resolve(result.paymentIntent);
        } else if (result.error) {
          reject(result);
        }
      }).catch(reject);
    });
  }
}
export default CardService.getInstance();
